import { render, staticRenderFns } from "./cardView.vue?vue&type=template&id=38606ba6"
import script from "./cardView.vue?vue&type=script&lang=js"
export * from "./cardView.vue?vue&type=script&lang=js"
import style0 from "./cardView.vue?vue&type=style&index=0&id=38606ba6&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports